import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Act } from '../model/recital';

export interface UpdateActParams {
  name?: string;
  description?: string;
  orderIndex?: number;
  duration?: number;
  notes?: string;
}

export const updateActAPI = async (
  showId: string,
  actId: string,
  params: UpdateActParams,
) => {
  const response = await baseAPI.patch<Act>(
    `/shows/${showId}/acts/${actId}`,
    params,
  );
  return response.data;
};

export const useUpdateActMutation = () => {
  return useMutation({
    mutationFn: async ({
      showId,
      actId,
      ...params
    }: UpdateActParams & { showId: string; actId: string }) => {
      return await updateActAPI(showId, actId, params);
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.SHOWS, variables.showId, KEYS.ACTS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACTS, variables.actId],
      });
    },
  });
};
